import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { resetClubNameFilter, resetDepartmentsFilter, setClubNameFilter, setDepartmentsFilter } from '../../../redux/reducers/common';
import AutoComplete from '../../AutoComplete';
import { Box } from '@mui/material';
import { getClubDepartments } from '../../../api/club';
import { setDepartmentList } from '../../../redux/reducers/evaluation';

const styles: any = {
  root: {
    display: 'flex',
    gap: '10px',
    marginLeft: '5px',
    justifyContent: 'space-between',
    paddingTop: '5px',
    marginRight: '25px',
  },
};

const FiltersWrapper: React.FC = () => {
  
  const selectedDepartments = useSelector((state:any) => state.common.departmentsFilter);
  const departmentList = useSelector((state:any) => state.evaluation.departmentList);
  const clubDetails = useSelector((state:any) => state.clubDetails);
  const selectedClubs = useSelector((state:any) => state.common.clubNameFilter);
  const clubData = [{ id: 0, name: "NONE" }, ...useSelector((state:any) => state.common.myClubs)];
  const isAdmin = useSelector((state:any) => state.common.isAdmin);

  const [departmentOptions, setDepartmentOptions] = useState(departmentList);
  const [clubNameOptions, setClubNameOptions] = useState(clubData);

  const dispatch = useDispatch();

  // useEffect(() => {
  //   if(selectedDepartments && selectedDepartments.length > 0) {
  //     const departmentIds = selectedDepartments?.map((d:any) => d.id);
  //     setDepartmentOptions(departmentList?.filter((d:any) =>  (departmentIds.includes(d.id) || departmentIds.length == 0)));
  //   }
  // }, [selectedDepartments]);

  useEffect(() => {
    const fetchDepartments = async () => {
        const response = await getClubDepartments({ clubId: clubDetails?.id });
        return response;
    }
    (departmentList.length == 0 ||
    departmentList == undefined) &&
    fetchDepartments()
    .then((res) => {
      dispatch(setDepartmentList(res));
      setDepartmentOptions(res);
    });
  }, [])
  
  const manageClubNameSelect = (club:any) => {
    const index = selectedClubs.findIndex((obj:any) => obj.id == club.id);
    let tempArr:any = [...selectedClubs];
      if (index !== -1) {
        tempArr.splice(index, 1);
    } else {
      tempArr.push(club);
    }
    dispatch(setClubNameFilter(tempArr));
  }

  const manageDepartmentSelect = (league:any) => {
    const index = selectedDepartments?.findIndex((obj:any) => obj.id == league.id);
    let tempArr:any = selectedDepartments && selectedDepartments?.length > 0 ? [...selectedDepartments] : [];
      if (index !== -1) {
        tempArr.splice(index, 1);
    } else {
      tempArr.push(league);
    }
    dispatch(setDepartmentsFilter(tempArr));
  }

  return (
    <div className="filtersWrapperRoot" style={styles.root}>
      {/* club name filter */}
      {
        isAdmin &&
        <Box sx={{ width: '200px' }}>
          <AutoComplete 
          options={clubNameOptions}
          selectedValues={selectedClubs}
          handleMenuClick={(d:any) => {manageClubNameSelect(d)}} 
          label={'Club Name'}
          clickReset={() => {dispatch(resetClubNameFilter())}}
          isMultiple={true}
          />
        </Box>
      }
      {/* Departments filter */}
      <Box sx={{ width: '200px' }}>
        <AutoComplete 
        options={departmentOptions}
        selectedValues={selectedDepartments}
        handleMenuClick={(d:any) => {manageDepartmentSelect(d)}} 
        label={'Departments'}
        clickReset={() => {dispatch(resetDepartmentsFilter())}}
        isMultiple={true}
        />
      </Box>
    </div>
  );
};

export default FiltersWrapper;
